import { Component, OnInit } from '@angular/core';
import { Common } from '../models/common';
import { AdvisorsService } from '../services/advisors.service';
import { ReassignFields } from '../models/reassign-fields';
import { FieldsService } from '../services/fields.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reassign-fields',
  templateUrl: './reassign-fields.component.html',
  styleUrls: ['./reassign-fields.component.css']
})
export class ReassignFieldsComponent implements OnInit {
  advisors: Common[];
  model: ReassignFields = new ReassignFields();

  constructor(private advisorsService: AdvisorsService, private fieldService: FieldsService,
     private toastr: ToastrService) {
    this.advisorsService.getAll().subscribe(data => {
      this.advisors = data;
    });
  }

  ngOnInit(): void {
  }

  onSubmit() {
    this.fieldService.reassign(this.model).subscribe(result => {
      this.toastr.success('Grabación exitosa', 'Éxito');
    }, (err: HttpErrorResponse) => {
      this.fieldService.handleError(err, this.toastr);
    });
  }
}
